<template>

  <b-container>
      <b-row align-h="center" style="margin-top: 3rem; margin-bottom: 1:rem;">
        <b-col cols="11">
          <h2 style="margin-bottom: 2rem">About</h2>
      <p v-html="$store.state.globalTheme.ABOUT"></p>
        </b-col>
    </b-row>
  </b-container>

</template>

<script>
    export default {
        name: "About"

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue